__turbopack_context__.v({
  "citationHighlighted": "GBk0IG_citationHighlighted",
  "paragraphwrapper": "GBk0IG_paragraphwrapper",
});
